module.exports = __webpack_public_path__ + "static/media/c-breakfast.b0d5bdf0.jpg";